module.exports = __webpack_public_path__ + "img/sesi-logo.40c1a7cd.png";